module.exports = __webpack_public_path__ + "img/iq.34e2ed01.svg";